const styles = {
    buttons: {
        float: 'right'
    },
    container: {
        position: 'relative',
        margin: '-23px 0 0 -5px',
        height: 'calc(100vh - 57px)'
    },
    map: {
        height: 300
    },
    rightIcon: {
        position: 'absolute',
        right: 10
    },
    mapFull: {
        height: '80vh'
    },
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
};

export default styles;



// WEBPACK FOOTER //
// src/containers/quiz/EditQuizPage/EditQuizPage.css.js